export const brandImages = {
  ED: "/images/onefront/bluestone/images/prime-visibility/discount-ed.svg",
  OP: "/images/onefront/bluestone/images/prime-visibility/discount-op.svg",
  GO: "/images/onefront/bluestone/images/prime-visibility/discount-go.svg",
  TR: "images/onefront/bluestone/images/prime-visibility/discount-tl.svg",
};
